import icons from "./Icons";
import { StyledIcon } from "./styles.js";

export default function Icon({ name, ...props }) {
  const Component = icons[name];

  return <StyledIcon {...props}>{Component ? <Component /> : null}</StyledIcon>;
}

